//#region src/types/index.ts
function headerFromPlainObject(headers, name) {
	const normalizedName = name.toLowerCase();
	const matchingKey = Object.keys(headers).find((key) => key.toLowerCase() === normalizedName);
	const value = matchingKey === void 0 ? void 0 : headers[matchingKey];
	return Array.isArray(value) ? value[0] ?? null : value ?? null;
}
/**
* Read a request header across fetch, Hono, and Express-style request shapes.
* Must not throw when `headers` is a plain object (Express `IncomingHttpHeaders`).
*/
function getRequestHeader(request, name) {
	if (request instanceof Request) return request.headers.get(name);
	if (request.raw instanceof Request) return request.raw.headers.get(name);
	const headers = request.headers;
	if (headers instanceof Headers) return headers.get(name);
	if (typeof request.header === "function") return request.header(name) ?? null;
	if (headers && typeof headers === "object") return headerFromPlainObject(headers, name);
	return null;
}
function getWebRequest(request) {
	if (request instanceof Request) return request;
	return request.raw instanceof Request ? request.raw : void 0;
}
//#endregion
export { getRequestHeader, getWebRequest };

//# sourceMappingURL=index.js.map